<div ref="billRef" style="display: none">
    <div style="font-family: monospace; font-size: 11px; width: 280px; height: auto; margin: 0 auto;">
        <div class="center bold">IN HÓA ĐƠN</div>
        <br/>
        <div>Khách hàng: {{ billData.partnerName }}</div>
        <div>Ngày Giao: {{ formatDate(billData.date) }}</div>
        <div class="line"></div>

        <div class="bill-line bold" style="font-weight: bold;">Sản phẩm</div>
        <table style="width: 100%; font-size: 11px; font-family: monospace;">
            <thead>
                <tr class="bold">
                    <td style="width: 20%; text-align: center;">SL</td>
                    <td style="width: 30%; text-align: center;">Giá</td>
                    <td style="width: 10%; text-align: center;">Thuế</td>
                    <td style="width: 40%; text-align: center;">Tiền Sau Thuế</td>
                </tr>
            </thead>
        </table>

        <div v-for="item in billData.items" :key="item.id">
            <div class="bill-line" style="white-space: pre-wrap;">{{ item.product_name }}</div>

            <table style="width: 100%; font-size: 11px; font-family: monospace;">
                <tbody>
                    <tr>
                        <td style="width: 20%; text-align: center;">{{ item.product_quantity }}</td>
                        <td style="width: 30%; text-align: center;">{{ format(item.product_selling_price) }}</td>
                        <td style="width: 10%; text-align: center;">{{ item.tax_rate }}%</td>
                        <td style="width: 40%; text-align: center;">{{ format(
                                (item.product_quantity * item.product_selling_price) + (item.tax_rate > 0 ? (item.product_quantity * item.product_selling_price * item.tax_rate) / 100 : 0)
                        ) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="line" style="border-top: 1px dashed #000; margin: 6px 0;"></div>
        <div class="bold right" style="font-weight: bold; text-align: right;">
            Tổng Tiền: {{ format(total) }} ₫
        </div>
        <div class="bold right" style="font-weight: bold; text-align: right;">
            Tổng Tiền Sau Thuế: {{ format(totalFeeTaxIncluded) }} ₫
        </div>
        <div class="right" style="text-align: center; margin-top: 30px">Cảm ơn quý khách!</div>
    </div>
</div>
